interface MultiFileInputGroup {
    inputs: HTMLInputElement[]
    max: number
    readonly count: boolean
    cloneInput: HTMLInputElement
    initMultiFile: () => void
    initFileInput: (input: HTMLInputElement) => void
    createNewInput: () => void
}

export default function(): MultiFileInputGroup {
    return {
        inputs: [],
        max: 8,
        get count() {
            return this.inputs.filter((input: HTMLInputElement) => input.files && input.files.length > 0).length
        },
        cloneInput: null,
        initMultiFile() {
            const input = this.$refs.original as HTMLInputElement;
            this.cloneInput = input.cloneNode(true) as HTMLInputElement;

            this.initFileInput(input);
            input.parentElement.querySelectorAll('input[type="file"][hidden]')
                .forEach(input => input.remove());

            input.closest('form').addEventListener('hf-success', () => {
                this.inputs.slice(1).forEach((fileInput: HTMLInputElement) => fileInput.remove());
                this.inputs = [this.inputs[0]];
            });
        },
        initFileInput(input) {
            this.inputs.push(input);

            input.addEventListener('change', () => {
                if (input.files && input.files.length > 0) {
                    this.createNewInput();
                } else if (input !== this.$refs.original) {
                    this.inputs = this.inputs.filter((fileInput: HTMLInputElement) => fileInput !== input);
                    input.remove();

                    this.inputs.forEach((fileInput: HTMLInputElement) => {
                        if (fileInput.name.endsWith('-0')) return;
                        fileInput.name = fileInput.name.replace(/.$/, this.inputs.indexOf(fileInput).toString());
                    })
                }
            })
        },
        createNewInput() {
            if (this.inputs.length > this.max) return;

            const newInput = this.cloneInput.cloneNode(true) as HTMLInputElement;
            newInput.name = newInput.name.replace('-0', `-${this.inputs.length}`);
            newInput.removeAttribute('id');
            this.$refs.original.parentElement.appendChild(newInput);
            this.initFileInput(newInput);
        }
    }
}
